import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { getOnTimeLandingPath, hasOnTimeAccess, pathAllowedForOnTime } from '../ontime/utils/access';
import LinkAccessLayer from '../ontime/components/LinkAccessLayer';
import { readLinkProfileSession } from '../ontime/auth/session';

export default function OnTimeRoute() {
  const { user, claims, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#08111f] text-white grid place-items-center px-4">
        <div className="text-center">
          <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-cyan-400 border-t-transparent" />
          <p className="text-sm text-slate-300">Loading Link…</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/ontime-login" state={{ from: location, preferredApp: 'ontime' }} replace />;
  }

  if (!hasOnTimeAccess(claims)) {
    return <Navigate to="/no-access?app=link" state={{ preferredApp: 'ontime', accessDeniedMessage: 'This account does not have access to Link. Ask an admin to activate Link for this username.' }} replace />;
  }

  const linkSession = readLinkProfileSession();
  const profileUnlocked =
    linkSession?.app === 'ontime' &&
    String(linkSession?.uid || '').trim() === String(user?.uid || '').trim() &&
    String(linkSession?.email || '').trim().toLowerCase() === String(user?.email || '').trim().toLowerCase() &&
    (!linkSession?.orgId || String(linkSession.orgId) === String(claims?.orgId || ''));


  if (!profileUnlocked) {
    return <LinkAccessLayer />;
  }

  if (!pathAllowedForOnTime(claims, location.pathname)) {
    return <Navigate to={getOnTimeLandingPath(claims)} replace />;
  }

  return <Outlet />;
}
